import { Tag } from 'foundations-components/transitional/components/Tag';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import { getSidebarIframeWindow } from 'InpageEditorUI/lib/domUtils/sidebarIframeDomUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InpageSectionTag = ({
  helpTitle,
  title
}) => {
  const sidebarIframeWindow = getSidebarIframeWindow();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Tag, {
      maxBlockSize: "24px",
      minInlineSize: "fit-content",
      use: "default",
      multiline: true,
      children: title
    }), helpTitle && /*#__PURE__*/_jsx(UIHelpIcon, {
      className: "m-left-2",
      title: helpTitle
      // @ts-expect-error Lazy TS
      ,
      tooltipProps: {
        _bodyElement: sidebarIframeWindow.document.body
      }
      // Edge case to make sure the help text popover closes on drop:
      // https://git.hubteam.com/HubSpot/ContentEditorUI/pull/17236#discussion_r2817804
    }, `forceRerender-${new Date()}`)]
  });
};
export default InpageSectionTag;